import { Injectable, Signal, computed, inject, signal } from '@angular/core';
import { LanguageService } from './language.service';
import { ProjectStateService } from './state/project-state.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageStore {
  private _currentLanguageCode = signal<LanguageCode>(
    (localStorage.getItem(LanguageService.STORAGE_KEY) as LanguageCode) ?? 'fr'
  );
  private languageDictionary = signal<LanguageDictionary | null>(null);
  readonly projectStateService: ProjectStateService =
    inject(ProjectStateService);
  public currentLanguage = computed(
    () => this.languageDictionary()?.[this._currentLanguageCode()]
  );

  /**
   * Set le langage de l'application
   * @param code
   */
  public setCurrentLanguageCode(code: LanguageCode): void {
    localStorage.setItem(LanguageService.STORAGE_KEY, code);
    this._currentLanguageCode.set(code);
    const expatClientInfos = this.projectStateService.selectExpatClientInfos();
    if (expatClientInfos) {
      expatClientInfos.language = code;
      this.projectStateService.updateExpatClientInfos(expatClientInfos, false);
    }
  }

  get currentLanguageCode(): Signal<LanguageCode> {
    return this._currentLanguageCode;
  }

  public addLanguageDictionary(dictionary: Language, code: LanguageCode): void {
    this.languageDictionary.update((dictionaries) => {
      if (dictionaries) {
        return { ...dictionaries, [code]: dictionary };
      }
      return { [code]: dictionary };
    });
  }
}

export type LanguageCode = 'fr' | 'en';
export type Language = Record<string, string>;
export type LanguageDictionary = Partial<Record<LanguageCode, Language>>;
